import type { ReturnDocument } from '@models/returns';

const ORDER_NUM_RE = /Order #(\d+)/;

export function getOrderNumFromContent(content: string): string | null {
  return content.match(ORDER_NUM_RE)?.[1] ?? null;
}

export function pickReturnForChat(
  returns: ReturnDocument[] | null | undefined,
  chatId: string
): ReturnDocument | null {
  return returns?.find((r) => r.chat_id === chatId) ?? returns?.[0] ?? null;
}
